export default {
  getSupplyRequestSegment: 'getsupplyrequestsegment?delegationid={delegationId}',
  postUploadFile: 'uploadfile',
  getFileOverview: 'getfileoverview?delegationid={delegationId}',
  deleteFile: 'deletefile?fileid={fileId}&delegationId={delegationId}',
  markDelegationIsComplete: 'markdelegationiscomplete?delegationid={delegationId}'
}
